exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".o-header__logos{display:flex;flex-direction:row;justify-content:space-between;align-items:center;gap:.8rem;padding-left:5px;width:90%}.img-logo{height:2rem;object-fit:cover}.o-nav__main{display:flex!important;justify-content:flex-end}.o-nav__logout,.o-nav__st{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:5px;padding:5px;color:#45423c;border-left:1px dotted #b2aea5}.o-nav__logout:hover,.o-nav__st:hover{text-decoration:none}.o-nav__logout--text,.o-nav__st--text{display:flex;flex-direction:column;align-items:center;text-align:center;margin:0}.o-nav__st--logo{width:24px;height:24px}@media only screen and (min-width:62.38em){.o-header__logos{padding:0;gap:1rem}.img-logo{height:3.5rem}.o-nav__st{padding:5px 10px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./client/app/common/otbNavbar/otbNavbar.less
// module id = 168
// module chunks = 0